export default __webpack_public_path__ + "static/media/003-road-sign.24bf084d.png";